<script>

import { Overlay } from '../../'
import { standardIndicator } from '../../workspace/standard-indicators.mjs'

export default {
    name: 'Aroon',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Aroon Indicator - Trend strength and direction',
                preset: {
                    name: 'Aroon $length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        upColor: '#26a69a',
                        downColor: '#ef5350'
                    }
                }
            }
        },
        use_for() { return ['Aroon'] },
        calc() {
            return {
                props: {
                    length: { def: 14, text: 'Length' }
                },
                conf: { renderer: 'Splines' },
                update: `const count = Math.max(2, Math.floor(length)) * 2 + 1;
                    const values = series => Array.from({length:count},(_,i)=>series[i]);
                    return (${standardIndicator.toString()})('Aroon',values(high),values(low),values(close),[],length);`
            }
        }
    }
}
</script>
